import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../common/CmnContext';
import { PracticeReseveContext } from '../PracticeReseveContext';
import Loading from '../../../common/loading/Loading';
import PracticeReserveSelectInstructor from './selectInstructor/PracticeReserveSelectInstructor';
import PracticeReserveTime from './time/PracticeReserveTime';
import PracticeReserveDatetime from './datetime/PracticeReserveDatetime';
import PracticeReserveSituation from './situation/PracticeReserveSituation';
import PracticeReserveFreeTalkTopick from './freeTalkTopick/PracticeReserveFreeTalkTopick';
import PracticeReserveRequest from './request/PracticeReserveRequest';
import PracticeReserveSubmit from './submit/PracticeReserveSubmit';
import PracticeReserveTicketLess from './ticketLess/PracticeReserveTicketLess';
import PracticeReserveAccessAlert from './accessAlert/PracticeReserveAccessAlert';


function PracticeReserveForm() {

  const { isPc } = useContext(cmnContext);
  const {
    lessonTermMinute, formRef,
    isLoading, isLesson,
    lsnMin, trialCount, isTicketLess,
    selectedScheduleId, selectedSituation,
  } = useContext(PracticeReseveContext);

  // (予約の可否)無料回数/チケットの不足
  const [canReserve, setCanReserve] = useState(false);


  // (予約の可否)無料回数/チケットの不足
  useEffect(() => {
    setCanReserve(
      !isTicketLess || //チケット数
      trialCount >= lsnMin / lessonTermMinute //無料回数
    );
  }, [lsnMin, trialCount, isTicketLess])


  return (
    <form
      ref={formRef}
      action="/practice"
      method="post"
    >
      <input type="hidden" name="mode" value="1"/>
      <input type="hidden" name="chat_type" value="1"/>
      <input type='hidden' name='sche_id' value={selectedScheduleId} />
      <input type='hidden' name='situation' value={selectedSituation} />

      {/* セッションする外国人講師 */}
      <PracticeReserveSelectInstructor />
      {/* 時間選択 */}
      <PracticeReserveTime />

      <>
        {isLesson ?
          <>
            {canReserve ?
              <>
                {isLoading ?
                  <Loading width={isPc? '5%':'10%'} />
                :
                <>
                  {/* 日程選択 */}
                  <PracticeReserveDatetime />
                </>
                }

                {/* 実践したい内容 */}
                <PracticeReserveSituation />

                {/* フリートーク：トピック */}
                <PracticeReserveFreeTalkTopick />

                {/* 講師へのコメント */}
                <PracticeReserveRequest />

                {/* 予約ボタン */}
                <PracticeReserveSubmit />
              </>
            :
              <>
                {/* 無料回数/チケット不足 */}
                <PracticeReserveTicketLess />
              </>
            }
          </>
        :
          <>
            {/* アクセス集中 */}
            <PracticeReserveAccessAlert />
          </>
        }
      </>

    </form>
  );
}
  
export default PracticeReserveForm;